import React, { useState } from "react";
import { Modal } from "antd";
import Input from "../form/Input";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import Brand from "../../api/Brand";
import ReactImageUploading from "react-images-uploading";

const EditBrandModal = ({ isOpen, onClose, initialBrandData, onSave }) => {
  const { t } = useTranslation();
  const [name, setName] = useState(initialBrandData?.name || "");
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState(null);
  const [images, setImages] = useState([]);

  const uploadBrandPhoto = async () => {
    try {
      const response = await Brand.uploadImage(initialBrandData.brand_id, images[0].file);
      toast.success(t("common.image-uploaded-successfully"));
      handleSuccess();
    } catch (error) {
      toast.error(t("common.something-went-wrong-please-try-again"));
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    setValidationErrors(null);

    Brand.update(initialBrandData.brand_id, {
      name: name,
    })
      .then(() => {
        if (images.length > 0) {
          uploadBrandPhoto();
        } else {
          toast.success("Changes Saved");
          handleSuccess();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          setValidationErrors(error.response.data.errors);
        } else {
          if (error?.response?.status !== 403) {
            toast.error(t("common.something-went-wrong-please-try-again"));
          }
        }
        setLoading(false);
      });
  };

  const handleSuccess = () => {
    setLoading(false);
    onClose();
    if (onSave) {
      onSave({ name });
    }
  };

  return (
    <Modal
      title={null}
      visible={isOpen}
      onCancel={onClose}
      closable={false}
      footer={null}
    >
      <div className="w-full">
        {/* Modal Header */}
        <div className="relative w-full bg-primary-500 px-6 py-4">
          <h2 className="text-xl text-white font-medium">Edit Brand</h2>
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 p-2 text-white/80 hover:text-white transition-colors"
            onClick={onClose}
          >
            <i className="far fa-times text-xl" />
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          <div className="space-y-6">
            {/* Brand Name Input */}
              <div>
                <Input
                  
                  name="name"
                  label={t("common.name")}
                  type="text"
                  value={name}
                  placeholder="Enter brand name"
                  error={
                    validationErrors && validationErrors.name
                      ? validationErrors.name[0]
                      : null
                  }
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              {/* Brand Image Upload */}
              <div className="mt-6">
                <ReactImageUploading
                  value={images}
                  onChange={(imageList) => setImages(imageList)}
                >
                  {({ imageList, onImageUpload }) => (
                    <div className="flex items-center gap-4">
                      <div className="h-28 w-28 bg-gray-100">
                        {imageList && imageList.length > 0 ? (
                          <img
                            className="h-full w-full object-cover"
                            src={imageList[0]?.dataURL}
                            alt=""
                          />
                        ) : initialBrandData?.photo ? (
                          <img
                            className="h-full w-full object-cover"
                            src={initialBrandData?.photo?.thumb_url}
                            alt=""
                          />
                        ) : (
                          <i
                            className="text-gray-400 text-3xl fa fa-plus cursor-pointer"
                            onClick={onImageUpload}
                          />
                        )}
                      </div>
                      <button
                        type="button"
                        className="rounded-lg px-4 py-2.5 text-sm font-semibold text-primary-600 shadow-sm ring-1 ring-inset ring-primary-600 hover:bg-primary-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={onImageUpload}
                      >
                        {t("common.upload-image")}
                      </button>
                    </div>
                  )}
                </ReactImageUploading>
              </div>
            </div>

          {/* Action Buttons */}
          <div className="mt-8 flex flex-col-reverse sm:flex-row gap-3">
            <button
              className="flex-1 px-4 py-2.5 text-sm font-medium rounded-lg border-2 border-gray-300 text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              onClick={onClose}
            >
              {t("common.cancel")}
            </button>
            <button
              className="flex-1 px-4 py-2.5 text-sm font-medium rounded-lg bg-primary-500 text-white hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:bg-primary-300 disabled:cursor-not-allowed inline-flex items-center justify-center"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <i className="fad fa-circle-notch fa-spin mr-2" />
              ) : null}
              {t("common.save")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditBrandModal;